import React from 'react';
import { useParams } from 'react-router-dom';
import CreateSubcontractingReport from './CreateSubcontractingReport';

const ViewSubcontractingReport = () => {
  const { id } = useParams();

  return (
    <CreateSubcontractingReport
      viewMode={true}
      reportId={id}
    />
  );
};

export default ViewSubcontractingReport;